export default "<h1>Default 原色</h1>\n<p>原色是精髓, 一切皆从原色开始.</p>\n"